// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__Wb5NO","header":"ReportDetails_header__3NdU-","title":"ReportDetails_title__24QJt","left":"ReportDetails_left__38YXZ"};